module.exports = __webpack_public_path__ + "img/summer-camp.47bc8166.svg";